<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter"><strong class="b">“I kissed you. And you liked it!”</strong></div>
<div class="p"><span>She took a sharp intake of breath, swallowing hard. He was right; she had liked it....</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“I think your ego may be getting in the way again, Jarrett,” Abbie told him. “You just can’t seem to accept that every female you meet isn’t going to fall willingly into your arms! I’ll admit I was curious for a while, but—despite what you may have thought—my husband was a more-than-capable lover. He knew exactly how to please a woman.” Her gaze was coolly steady on Jarrett’s now angry face. “No other man could ever take his place in my life.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“I don’t want to take his place!” Jarrett visibly recoiled. “You already know my views on marriage—”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“And you already know mine on affairs....”</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459251915_fm01.vue?8b6f6e54